import Step7 from './Step7-compose';

export default Step7;
